import { graphql } from "../graphql";

export const GetNavigation = graphql(`
  query GetNavigation($locale: String, $preview: Boolean) {
    navigationCollection: c100NavigationCollection(
      locale: $locale
      preview: $preview
      limit: 1
    ) {
      items {
        ...NavigationContent
      }
    }
  }
`);
